module.exports = __webpack_public_path__ + "static/media/learn-more-slp-image-1.41714407.jpg";